export default __webpack_public_path__ + "static/news-event-banner-8da63e9d17649da4b3d6e5894374119f.webp";